export enum SortBy {
  BPS_HIGHEST = 'BPS® Highest',
  BPS_LOWEST = 'BPS® Lowest',
  LAST_UPDATED_ASC = 'Newest',
  LAST_UPDATED_DESC = 'Oldest',
  CUSTOMER_ASC = 'Customer Ascending',
  CUSTOMER_DESC = 'Customer Descending',
  DEAL_TYPE_ASC = 'Deal Type Ascending',
  DEAL_TYPE_DESC = 'Deal Type Descending',
  OFFER_DESC = 'Incentive Highest',
  OFFER_ASC = 'Incentive Lowest',
  EXPIRING_IN_ASC = 'Expires In Ascending',
  EXPIRING_IN_DESC = 'Expires In Descending',
}

export const AvailableSortByArguments = [
  SortBy.LAST_UPDATED_ASC,
  SortBy.LAST_UPDATED_DESC,
  SortBy.BPS_HIGHEST,
  SortBy.BPS_LOWEST,
  SortBy.OFFER_DESC,
  SortBy.OFFER_ASC,
  SortBy.EXPIRING_IN_ASC,
  SortBy.EXPIRING_IN_DESC,
];
